<template>
  <section>
    <v-card outlined>
      <v-expansion-panels v-if="pages.length" accordion focusable>
        <v-expansion-panel v-for="(items, hostname) in groupedPages" :key="hostname" expanded>
          <v-expansion-panel-header>
            <div>
              <v-chip color="primary" class="mr-4">{{ items.length }}</v-chip>
              <span>{{ hostname }}</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager>
            <div class="mt-4">
              <page-review-item
                v-for="(item, index) in items"
                :key="index"
                :item="item"
                :entities="entities"
                :page-ids="pageIds"
                :page-types="pageTypes"
                :sites="sites"
                :languages="languages"
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div v-else class="text-center pa-4">No results found</div>
    </v-card>
  </section>
</template>

<script>
import { groupBy } from 'lodash-es'
import PageReviewItem from './page-review-item'
export default {
  components: { PageReviewItem },
  props: {
    entities: {
      type: Array,
      required: true,
    },
    pageTypes: {
      type: Array,
      required: true,
    },
    pageIds: {
      type: Array,
      required: true,
    },
    sites: {
      type: Array,
      required: true,
    },
    languages: {
      type: Array,
      required: true,
    },
    pages: {
      type: Array,
      required: true,
    },
    hasBeenCreated: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    groupedPages() {
      return groupBy(this.pages, 'site.hostname')
    },
  },
}
</script>
